import { MainThunkDispatch, State } from "../../Reducers"
import { apiFetch } from "../Client/NetworkActions"
import { apiEndpoints } from "../../Routes/api"
import {
    APIMeasurerMetric,
    APIMetricConstraintList
} from "../../Models/API/APIMetric"
import { MetricsAPIType } from "../Types"
import { Result } from "../../Models/Utility/Result"
import { asError } from "../../Helpers/Functions/error"
import { MetricsAction } from "../../Reducers/API/Metrics/Metrics"
import { hasMore } from "../../Models/Client/RemoteData"
import { safePromise } from "../../Helpers/Functions/promise"

export const listMetricConstraints =
    (name?: string, page: number = 1, pageSize: number = 100) =>
    async (dispatch: MainThunkDispatch) => {
        const action: MetricsAction = {
            type: MetricsAPIType.metricConstraintListFetchStateChanged,
            meta: { page, pageSize, name },
            payload: "loading"
        }

        try {
            dispatch(action)

            const res = await dispatch(
                apiFetch<APIMetricConstraintList>(
                    `LIST_METRIC_CONSTRAINTS_${JSON.stringify({
                        page,
                        pageSize,
                        name
                    })}`,
                    apiEndpoints.metricConstraint({ page, pageSize, name })
                )
            )

            if (res === undefined) {
                return
            }

            dispatch({
                ...action,
                payload: Result.ok({ total: res.total, records: res.content })
            })
        } catch (e) {
            dispatch({
                ...action,
                payload: Result.error<any>(asError(e).message)
            })
        }
    }

export const loadMoreMetricConstraints =
    () => (dispatch: MainThunkDispatch, getState: () => State) => {
        const remoteData = getState().api.metrics.metricConstraints
        const pages = remoteData.list?.pages.length ?? 0

        if (hasMore(remoteData)) {
            dispatch(
                listMetricConstraints(remoteData.list?.params.name, pages + 1)
            )
        }
    }

export const getAllMetricsByAppID =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        const action: MetricsAction = {
            type: MetricsAPIType.setMeasurerMetricList,
            meta: { appID },
            payload: "loading"
        }
        dispatch(action)
        const { data, error } = await safePromise(
            dispatch(
                apiFetch<APIMeasurerMetric[]>(
                    `GET_ALL_METRICS_${appID}`,
                    apiEndpoints.getAllMetricsByAppID({ appID })
                )
            )
        )

        if (error !== undefined || data === undefined) {
            return
        }

        dispatch({
            ...action,
            payload: Result.ok(data)
        })
    }
